import React, { useState } from "react";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import BoxWrapper from "src/Components/WebsiteComponents/BoxWrapper";
import SimpleInput from "src/Components/SimpleInput";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-toastify/dist/ReactToastify.css";
import {
  faAngleDown,
  faArrowDown,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { getShippingAddresses } from "src/helpers/helperFunctions";
import { IAddressData } from "src/types/GlobalInterfaces";
import httpRequest from "src/helpers/httpRequest";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import { useNavigate } from "react-router-dom";
import DileveryAddressTitle from "src/Components/GlobalComponents/DileveryAddressTitle";

function NonValidPrescription() {
  const [prescription, setPrescription] = React.useState<File | null>(null);
  const [loader, setLoader] = useState<boolean>(false);
  const { address } = useSelector((state: RootState) => state.cartSlice);
  const [currentAddress, setCurrentAddress] = useState<
    IAddressData | null | string
  >(null);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!prescription) {
      toast.error("Please upload Prescription File");
      return;
    }

    if (typeof address === "string" || !address) {
      toast.error("Please add a delivery address first");
      return;
    }

    let payload = {
      document: prescription,
      deliveryTo:
        typeof address === "string"
          ? address
          : address?.fullAddress || address?.streetAddress,
      addressId: typeof address === "string" ? address : address?._id,
      havePrescription: false,
    };

    let formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value instanceof File) {
        formData.append(key, value);
      } else {
        formData.append(key, value as string);
      }
    });
    setLoader(true);
    const { res, err } = await httpRequest<{ data: IAddressData | null }>({
      path: "/customer-prescription/add",
      method: "put",
      params: formData,
      header: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (res) {
      toast.success("Prescription uploaded successfully");
      navigate("/");
    } else {
      toast.error(err?.message || "Something went wrong");
    }
    setLoader(false);
  };

  return (
    <div className="w-full bg-banner-white-image py-4">
      <div className="view-area-width">
        <div className="w-full flex flex-col gap-4 max-w-[850px] lg:max-w-[80%] mx-auto">
          <BoxWrapper title="Select Delivery Address">
            <DileveryAddressTitle hasOwnModal className="font-size-14px" />
          </BoxWrapper>
          <BoxWrapper title="Upload Documents">
            <ImageUpload
              onImageChange={(image) => {
                setPrescription(image);
              }}
              allowedExtensions={[".jpg", ".jpeg", ".png", ".pdf"]}
              allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
              image={prescription}
              newUiFrontend={true}
              extraClasses="w-full h-[300px] border-1 border-[#00A297] "
              id="non-valid-prescription-image-upload"
              labelId="non-valid-prescription-image-upload-label"
            />
          </BoxWrapper>
          <div className="w-full flex justify-end mb-4">
            <GradientBtn
              onPress={handleSubmit}
              ButtonText="Proceed"
              btnExtraStyle={{
                width: "fit-content",
              }}
              loader={loader}
              fontfamilyBtn="font-Lexend-SemiBold"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NonValidPrescription;
